<template>
  <footer class="blog-footer">
    <div class="blog-footer-container">
      <BlogFooterTop />
      <FooterDevelopers :messages="messages" />
    </div>
  </footer>
</template>

<script lang="ts" setup>
import BlogFooterTop from '@components/Blog/Footer/BlogFooterTop.vue';
import FooterDevelopers from '@components/Footer/FooterDevelopers.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();
const messages = computed(() => resultsStore?.messages?.blog);
</script>

<style lang="scss" scoped>
.blog-footer {
  margin-top: auto;
  background-color: #f6f6f6;
  :deep(svg) {
    fill: #030304;
  }
}
.blog-footer-container {
  @extend %container;
}
</style>
